import { AppContent } from '../AppContent';

const footer: AppContent['footer'] = {
  footerContent: [
    {
      text: 'Cookies',
      link: 'https://www.lloydsbank.com/help-guidance/privacy/cookies.html?WT.ac=lloyds-business-all-footer-page_terminus-page-cookies',
    },
    {
      text: 'Legal',
      link: 'https://www.lloydsbank.com/business/legal.html?WT.ac=lloyds-business-all-footer-page_terminus-page-legal',
    },
    {
      text: 'Privacy',
      link: 'https://www.lloydsbank.com/business/privacy.html?WT.ac=lloyds-business-all-footer-page_terminus-page-privacy',
    },
    {
      text: 'Security',
      link: 'https://www.lloydsbank.com/business/security.html?WT.ac=lloyds-business-all-footer-page_terminus-page-security',
    },
    {
      text: 'Lloyds Banking Group',
      link: 'https://www.lloydsbankinggroup.com',
    },
    {
      text: 'Rates and charges',
      link: 'https://www.lloydsbank.com/business/commercial-banking/rates-and-charges.html',
    },
  ],
};

export default footer;
